import axios from "axios";
import getToken from "./getToken.js";

const backendUrl = process.env.REACT_APP_BACKEND_RESUME_URL;

const getUserResumeById = async (resumeId) => {
  const token = getToken();
  const resumeUrl = `${backendUrl}/${resumeId}`;
  try {
    const response = await axios.get(resumeUrl, {
      headers: { token: token },
    });
    // Based on ResumeViewer.jsx, the resume data is within response.data.resume
    return response.data.resume;
  } catch (err) {
    console.error(`Failed to fetch resume with id ${resumeId}`, err);
    throw err; // Re-throw the error so the calling component can handle it.
  }
};

export default getUserResumeById;
